// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Icon{display:inline-flex !important;justify-content:center;align-items:center;font-size:1em}.Icon svg{width:1em;height:1em}.Icon svg path,.Icon svg polygon,.Icon svg rect,.Icon svg circle,.Icon svg ellipse,.Icon svg line,.Icon svg polyline{fill:currentColor}\n", ""]);
// Exports
module.exports = exports;
